import {StrictMode} from 'react'
import 'react-phone-number-input/style.css'
import './index.css'
import App from './App'
import {I18n, languageCodeFromHostname} from './common/i18n'
import {createRoot} from 'react-dom/client'

I18n.setLanguage(
  window.localStorage.getItem('bring-rop-language') || languageCodeFromHostname(window.location.hostname),
)
document.title = I18n.i18n().hero.title

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
